import { connect } from "react-redux";

import { reopenGrn } from "actions/grns";

import Status from "./components/Status";

import { ReactComponent as ConfirmGrnIcon } from "icons/confirm-grn.svg";

const Confirm = ({ data, is_completing, reopenGrn }) => {
  const is_disabled =
    is_completing ||
    data.grn_lines.filter(
      ({ is_deleted, counting_state }) =>
        !is_deleted && counting_state === "pending"
    ).length > 0;

  if (data?.status === "open" || data.status === "active") {
    return (
      <>
        <button
          disabled={is_disabled}
          type="submit"
          className="btn btn-sm btn-green"
        >
          <ConfirmGrnIcon />
          <span>{is_completing ? "Proszę czekać..." : "Potwierdź przyjęcie"}</span>
        </button>
      </>
    );
  }
  return (
    <>
      {data?.status !== "finished" && (
        <button
          type="button"
          className="btn-revert"
          disabled={is_completing}
          onClick={() => reopenGrn(data.id)}
        >
          {is_completing ? "Proszę czekać..." : "Cofnij"}
        </button>
      )}
      <Status />
    </>
  );
};

export default connect(
  ({ grn }) => ({ data: grn?.data, is_completing: grn?.is_completing }),
  (dispatch) => ({
    reopenGrn: (id) => dispatch(reopenGrn(id)),
  })
)(Confirm);
